var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDullFeatureArrowRightBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32.9351,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-180 32 32.9351)",
    fill: "#1776EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5583 21.372C13.629 21.4448 13.7131 21.5026 13.8058 21.542C13.8985 21.5815 13.9979 21.6018 14.0983 21.6018C14.1988 21.6018 14.2982 21.5815 14.3909 21.542C14.4836 21.5026 14.5677 21.4448 14.6384 21.372L18.4416 17.4868C18.5129 17.4146 18.5695 17.3287 18.6081 17.234C18.6467 17.1393 18.6666 17.0377 18.6666 16.9351C18.6666 16.8326 18.6467 16.731 18.6081 16.6363C18.5695 16.5416 18.5129 16.4557 18.4416 16.3835L14.6384 12.4983C14.5677 12.4255 14.4836 12.3677 14.3909 12.3282C14.2982 12.2888 14.1988 12.2685 14.0983 12.2685C13.9979 12.2685 13.8985 12.2888 13.8058 12.3282C13.7131 12.3677 13.629 12.4255 13.5583 12.4983C13.487 12.5706 13.4304 12.6565 13.3918 12.7512C13.3532 12.8459 13.3333 12.9474 13.3333 13.05C13.3333 13.1526 13.3532 13.2541 13.3918 13.3488C13.4304 13.4435 13.487 13.5295 13.5583 13.6017L16.8291 16.9351L13.5583 20.2686C13.487 20.3408 13.4304 20.4268 13.3918 20.5214C13.3532 20.6161 13.3333 20.7177 13.3333 20.8203C13.3333 20.9229 13.3532 21.0244 13.3918 21.1191C13.4304 21.2138 13.487 21.2997 13.5583 21.372Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDullFeatureArrowRightBtn);
export default __webpack_public_path__ + "static/media/dull_feature_arrow_right_btn.d2892ae361279edd615a4261025427ab.svg";
export { ForwardRef as ReactComponent };